// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"navigationFooter_footerContainer__Imab3","simpleFooter":"navigationFooter_simpleFooter__fSa7P","basicFooter":"navigationFooter_basicFooter__IZcZe"};